import * as Yup from 'yup';
import { PqrNotificationClient } from '../../../../../../shared/types/modules/pqr';

export const initialValues: PqrNotificationClient = {
    email: '',
    phone: '',
};

export const validationSchema = Yup.object({
    email: Yup.string()
        .required('El e-mail notificación es obligatorio')
        .max(
            1000,
            'El e-mail notificación debe tener 1000 caracteres alfanuméricos como máximo'
        )
        .test(
            'multiple-emails',
            'Formato de correo no válido, recuerde que puede incluir más de un correo separado por ";"',
            (value) => {
                if (!value) return false;

                const emails = value.split(';').map((email) => email.trim());
                const emailRegex =
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                return emails.every((email) => emailRegex.test(email));
            }
        ),
    phone: Yup.string()
        .max(
            150,
            'El teléfono notificación debe tener 150 caracteres alfanuméricos como máximo'
        )
        .matches(
            /^[a-zA-Z0-9]*$/,
            'El teléfono notificación solo debe contener caracteres alfanuméricos'
        ),
});
